<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<a id="page_3"></a>
<h1 class="title">MAIL BY RAIL</h1>
<p class="half1">THE STORY OF THE POST OFFICE AND THE RAILWAYS</p>
<p class="author">PETER JOHNSON</p>
<div class="image_containerf1">
<img alt="images" src="images/pub.jpg"/>
</div>
<div class="image_containerh">
<img alt="images" src="images/title.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?289606a5